module.exports = __webpack_public_path__ + "static/media/warm.dcfdfb4e.jpg";